<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="900px">
            <div class="dialogContent">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="模型名称" prop="modelName">
                        <el-input v-model="form.modelName" placeholder="请输入模型名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模型分类" prop="modelType">
                        <el-cascader
                            v-model="form.modelType"
                            :options="modelTypeList" style="width: 100%;" placeholder="请选择模型分类"></el-cascader>
                    </el-form-item>
                    <el-form-item label="模型图片" prop="urlList">
                        <div style="display: flex;">
                            <uploadImage
                                :buttonName="'上传图片'"
                                :img-file="form.urlList"
                                :width="'224'"
                                :height="'143'"
                                @avatarChange="avatarChange($event)"
                                @getDragImgFile="getDragImgFile($event)"
                                @deleteImg="deleteImg($event)"
                            ></uploadImage>
                        </div>
                    </el-form-item>
                    <el-form-item label="上传模型" prop="fileList">
                        <uploadFile
                            :buttonName="'上传模型'"
                            :fileList="form.fileList"
                            :fileType="'obj,stl,OBJ,STL'"
                            :fileTypeMessage="'请上传类型为obj,stl的模型文件'"
                            @fileListChange="fileListChange"
                            @deleteFile="deleteFile"
                            @getDragFile="getDragFile"
                        ></uploadFile>
                    </el-form-item>
                    <el-form-item label="模型详情" prop="modelContent">
                        <el-input type="textarea" :autosize="{ minRows: 6}" v-model="form.modelContent" placeholder="请输入模型详情"></el-input>
                    </el-form-item>
                    <el-form-item label="模型属性" prop="modelProperty">
                        <el-radio-group v-model="form.modelProperty">
                            <el-radio label="免费">免费</el-radio>
                            <el-radio label="付费">付费</el-radio>
                            <el-radio label="仅预览">仅预览</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="模型价格" prop="modelPrice">
                        <el-input v-model="form.modelPrice" placeholder="请输入模型价格" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">元</span>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import uploadImage from '@/components/uploadImage'
    import uploadFile from '@/components/uploadFile'
    export default {
        name: "materialManagementDialog",
        data() {
            return {
                dialogVisible: false,
                title: '',
                id: '',
                form: {
                    modelName: '',
                    modelType: [],
                    modelPrice: '',
                    modelContent: '',
                    urlList: [],
                    modelProperty: '',
                    fileList: []
                },
                rules: {
                    modelName: [
                        {required: true, message: '请输入模型名称', trigger: 'blur'}
                    ],
                    modelType: [
                        {required: true, message: '请选择模型分类', trigger: 'change'}
                    ],
                    urlList: [
                        {required: true, message: '请上传模型图片'}
                    ],
                    fileList: [
                        {required: true, message: '请上传模型文件'}
                    ],
                    modelPrice:[
                        {required: true, validator: this.validatorNum,trigger: 'blur'}
                    ],
                    modelContent: [
                        {required: true, message: '请输入服务详情', trigger: 'blur'}
                    ],
                    modelProperty: [
                        {required: true, message: '请选择模型属性', trigger: 'change'}
                    ],
                },
                modelTypeList: [
                    {
                        value: '工业模型',
                        label: '工业模型',
                        children: [
                            {
                                value: '汽车配件',
                                label: '汽车配件'
                            }, {
                                value: '机床配件',
                                label: '机床配件'
                            }, {
                                value: '生物医疗',
                                label: '生物医疗'
                            }, {
                                value: '航空航天',
                                label: '航空航天'
                            }, {
                                value: '其它',
                                label: '其它'
                            }
                        ]
                    },
                    {
                        value: '建筑模型',
                        label: '建筑模型',
                        children: [
                            {
                                value: '标志建筑',
                                label: '标志建筑',
                            },
                            {
                                value: '普通建筑',
                                label: '普通建筑',
                            },
                            {
                                value: '城堡寺庙',
                                label: '城堡寺庙',
                            },
                            {
                                value: '其它',
                                label: '其它',
                            }
                        ]
                    }
                ]
            }
        },
        components: {
            uploadImage,
            uploadFile
        },
        methods: {
            init(type,id) {
                this.dialogVisible = true
                this.reset()
                if (type === 'add') {
                    this.title = '新增'
                    this.id = ''
                } else {
                    this.title = '编辑'
                    this.id = id
                }
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.$message({
                            type: 'success',
                            message: '保存成功！'
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 表单数字校验
            validatorNum(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入服务价格'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            },
            // 上传成功
            avatarChange(val) {
                this.form.urlList = val
                this.$refs.ruleForm.validateField('urlList')
            },
            // 删除图片
            deleteImg(val) {
                this.form.urlList = val
                this.$refs.ruleForm.validateField('urlList')
            },
            // 获取拖拽后的图片
            getDragImgFile(file) {
                if (file) {
                    this.form.urlList = file
                    this.$refs.ruleForm.validateField('urlList')
                }
            },
            // 获取拖拽后的模型文件
            fileListChange(file){
                this.form.fileList = file
                this.$refs.ruleForm.validateField('fileList')
            },
            // 删除模型文件
            deleteFile(file){
                this.form.fileList = file
                this.$refs.ruleForm.validateField('fileList')
            },
            // 上传模型文件
            getDragFile(file){
                this.form.fileList = file
                this.$refs.ruleForm.validateField('fileList')
            },
            reset() {
                this.form = {
                    modelName: '',
                    modelType: [],
                    modelPrice: '',
                    modelContent: '',
                    urlList: [],
                    modelProperty: '',
                    fileList: []
                }
                this.$nextTick(()=>{
                    if(this.$refs.ruleForm){
                        this.$refs.ruleForm.clearValidate()
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        .thumbnailClass{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            .avatar{
                width: 80px;
                height: 80px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 80px;
                font-size: 24px;
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        .detailsClass{
            /*/deep/.el-form-item__label{*/
            /*float: none;*/
            /*}*/
            /*/deep/.el-form-item__content{*/
            /*margin-left: 0 !important;*/
            /*}*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/model/modelManagementDialog.vue